function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import omitProps from '@hocs/omit-props';
import elementRectObserver from 'element-rect-observer';
import Layout from './Layout';

var LayoutWithMeasurement = function LayoutWithMeasurement(_ref) {
  var dimensions = _ref.dimensions,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['dimensions', 'children']);

  return React.createElement(
    Layout,
    props,
    children(dimensions)
  );
};

export default compose(withState('dimensions', 'setDimensions', function (_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === undefined ? 0 : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === undefined ? 0 : _ref2$height;
  return { width: width, height: height };
}), withHandlers({
  onResize: function onResize(_ref3) {
    var dimensions = _ref3.dimensions,
        setDimensions = _ref3.setDimensions,
        children = _ref3.children,
        _onResize = _ref3.onResize;
    return function (_ref4) {
      var width = _ref4.width,
          height = _ref4.height;

      if (dimensions.width !== width || dimensions.height !== height) {
        if (children.length > 0) {
          setDimensions({ width: width, height: height });
        }

        if (typeof _onResize === 'function') {
          _onResize({ width: width, height: height });
        }
      }
    };
  }
}), withHandlers(function () {
  var stopObserving = null;

  return {
    onRef: function onRef(_ref5) {
      var onResize = _ref5.onResize;
      return function (domElement) {
        if (domElement != null) {
          stopObserving = elementRectObserver(domElement, onResize);
        } else if (stopObserving) {
          stopObserving();
        }
      };
    }
  };
}), omitProps('setDimensions', 'width', 'height', 'onResize'))(LayoutWithMeasurement);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@primitives/layout/build/web/LayoutWithMeasurement.js
// module id = 469
// module chunks = 0